import React from "react";
import styled from "styled-components";

const Logo = styled.div``;

const LogoImage = styled.img`
  @media only screen and (max-width: 767px) {
    height: 32px;
    width: auto;
  }
  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {
    height: 32px;
    width: auto;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    height: 32px;
    width: auto;
  }
`;

const SundayLogo = ({ content }: any): JSX.Element => {
  return (
    <Logo>
      <a href={content?.headerLogoLink}>
        <LogoImage
          loading="lazy"
          height="62"
          src={content?.headerLogoImageUrl}
          alt="sunday-logo"
        />
      </a>
    </Logo>
  );
};

export default SundayLogo;
